import React from "react";
import styles from "./test-connection.module.scss";
import Button from "components/shared-ui/button";
import clsx from "clsx";
import IComponentProps from "components/shared-ui/common/component-props";
import { IAppState } from "redux/reducers";
import { connect } from "react-redux";
import CloseIcon from "@mui/icons-material/Close";
import DoneIcon from "@mui/icons-material/Done";
import { ThunkDispatch } from "redux-thunk";
import { Action } from "redux";
import { storageActions } from "redux/actions/storage";
import { storageUtils } from "utils/storage-utils";
import { IShardRepositoryTestConnectionRequest } from "api/entities/shard-repository";

const mapStateToProps = (state: IAppState) => ({
  isTestConnectionSuccess: state.storage.testConnectionFlag,
});

const mapDispatchToProps = (
  dispatch: ThunkDispatch<IAppState, void, Action>
) => {
  return {
    testConnection: (payload: IShardRepositoryTestConnectionRequest) => {
      dispatch(storageActions.testConnection(payload));
    },
  };
};

interface ITestConnectionProps
  extends IComponentProps,
    ReturnType<typeof mapStateToProps>,
    ReturnType<typeof mapDispatchToProps> {
  testConnectionRequest: IShardRepositoryTestConnectionRequest;
}

export function TestConnection(props: ITestConnectionProps) {

  return (
    <div
      className={clsx("root", props.className)}
      style={props.style}
      data-testid={props.testId}
    >
      <Button
        testId="test-connection-button"
        className={styles.button}
        colors="secondary"
        disabled={props.disabled || !storageUtils.isTestConnectionRequestValid(props.testConnectionRequest, true)}
        onClick={() => props.testConnection(props.testConnectionRequest)}
      >
        Test Connection
      </Button>
      {props.isTestConnectionSuccess !== null && (
        <div
          className={clsx("result", {
            ["result--success"]: props.isTestConnectionSuccess,
            ["result--fail"]: !props.isTestConnectionSuccess,
          })}
        >
          {props.isTestConnectionSuccess ? (
            <>
              <DoneIcon className={styles.icon} />
              <span>Connection all good!</span>
            </>
          ) : (
            <>
              <CloseIcon className={styles.icon} />
              <div>
                <div>Connection Failure!</div>
                <div className={styles.result__description}>
                  Please try again or check with your provider.
                </div>
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(TestConnection);
